// qs-AppLoadingScreen.vue
<template>
  <div class="app-loading-screen">
    <div class="loading-content">
      <div class="logo-container">
        <QsLogo 
          :size="120" 
          :animate="true" 
        />
        <h1>VectorSketch</h1>
        <p class="claim">
          Vector Scribble Drawing
        </p>
        <p class="by">
          by anomie.at
        </p>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">import QsLogo from './qs-Logo.vue'</script>

<style scoped>
.app-loading-screen {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: #ebbcbc;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
}

.loading-content {
  text-align: center;
  color: #333;
}

.logo-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-bottom: 2rem;
}



.loading-content h1 {
  font-size: 2rem;
  margin: 0 0 0.5rem 0;
  color: #333;
}

.claim {
  font-size: 1.1rem;
  margin: 0 0 0.25rem 0;
  color: #666;
  font-weight: 500;
}

.by {
  font-size: 0.9rem;
  margin: 0 0 1rem 0;
  color: #888;
  font-style: italic;
}

.spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-top: 3px solid rgba(0, 0, 0, 0.6);
  border-right: 3px solid rgba(0, 0, 0, 0.3);
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin: 0 auto 1rem auto;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

.loading-content p {
  margin: 0;
  color: #666;
}
</style>